import { render, staticRenderFns } from "./LegacyFacilityPortal.vue?vue&type=template&id=479014b1&"
import script from "./LegacyFacilityPortal.vue?vue&type=script&lang=js&"
export * from "./LegacyFacilityPortal.vue?vue&type=script&lang=js&"
import style0 from "./LegacyFacilityPortal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports